export type MissionType = 'MONEY_CUP' | 'COLLECT_ITEM' | 'REACH_X' | 'INTERACT';
export type MissionData = { id: string; type: string; target: number | string };

export type GameState = {
  walletValueInCup: number;
  playerX: number;
  collectedItems: Set<string>;
  interactedTargets: Set<string>;
};

export const MISSION_TYPES: Record<MissionType, string> = {
  MONEY_CUP: 'Collect target amount in CUP',
  COLLECT_ITEM: 'Collect specified item',
  REACH_X: 'Reach target X position',
  INTERACT: 'Interact with target entity',
};

export class Mission implements IMission {
  public id: string;
  public type: MissionType;
  public target: number | string;
  public progress: number;
  public complete: boolean;

  constructor(id: string, type: MissionType, target: number | string) {
    this.id = id;
    this.type = type;
    this.target = target;
    this.progress = 0;
    this.complete = false;
  }

  update(state: GameState): void {
    switch (this.type) {
      case 'MONEY_CUP':
        this.progress = state.walletValueInCup;
        break;
      case 'REACH_X':
        this.progress = state.playerX;
        break;
      case 'COLLECT_ITEM':
        this.progress = state.collectedItems.has(this.target as string) ? 1 : 0;
        break;
      case 'INTERACT':
        this.progress = state.interactedTargets.has(this.target as string) ? 1 : 0;
        break;
    }
    if (this.isComplete()) {
      this.complete = true;
    }
  }

  isComplete(): boolean {
    if (this.type === 'INTERACT') {
      return this.progress >= 1;
    }
    if (this.type === 'COLLECT_ITEM') {
      return this.progress >= 1;
    }
    return this.progress >= (this.target as number);
  }

  getProgress(): number {
    return this.progress;
  }
}

export interface IMission {
  id: string;
  type: MissionType;
  target: number | string;
  progress: number;
  complete: boolean;
  update(state: GameState): void;
  getProgress(): number;
  isComplete(): boolean;
}
